import styled from "styled-components";
import {TextField, Button} from "@mui/material";

export const ContactMeWrapper = styled.div`
    display: block;
    z-index: 1;
    height: 860px;
    width: 100%;
    max-width: 1100px;
    margin: auto;
    padding: 0 24px;
    justify-content: center;
`

export const HeadingOne = styled.h1`
    font-family: 'Poppins', sans-serif, 'arial';
    font-weight: 600;
    font-size: 72px;
    text-align: center;
    margin-block-end: 0;
`

export const HeadingFour = styled.h2`
    font-family: 'Roboto', sans-serif, 'arial';
    font-weight: 400;
    font-size: 20px;
    color: #9b9b9b;
    line-height: 1.5;
    text-align: center;
    margin-block-start:0;
    margin-block-end:5%;

    
`
export const Form = styled.form`
    display: grid;
    column-gap: 10px;
    row-gap: 1em;
    grid-template-columns : 1fr 1fr;
    grid-template-rows: repeat(3, 1fr);
    justify-items: stretch;
`

export const TxtField = styled(TextField)`

`

export const TxtFieldM = styled(TxtField)`
    grid-column-start: 1;
    grid-column-end: 4;
    width: 99%;
`

export const Btn = styled(Button)`
    grid-column-start: 1;
    grid-column-end: 4;
    width: 80%;
    justify-self:center;
`
